var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.$t('appointment.formCreate.labels.visitorName'),"rules":_vm.rules,"hide-details":"auto","outlined":""},on:{"input":_vm.handleVisitorName}})}
var staticRenderFns = []

export { render, staticRenderFns }